import { Wrapper, Article, Header, Content, Footer } from './styles'

export default function CancellationPolicy() {
  return (
    <Wrapper>
      <Article>
        <Header>
          <img src="/logo.svg" alt="MeniuDigital" className="logo" />
          <h1>Politica de retur și anulare</h1>
          <div className="subtitle">Actualizat: 13 Noiembrie 2024</div>
        </Header>

        <Content>
          <h2>Retur produse fizice</h2>
          <p>MeniuDigital este o platformă de digitalizare a meniurilor care oferă exclusiv servicii digitale.</p>

          <div className="highlight">
            <strong>Nu vindem produse fizice, prin urmare nu există posibilitatea returnării de bunuri materiale.</strong>
            <br />
            <br />
            Toate serviciile noastre sunt furnizate digital prin intermediul platformei web, fără nicio componentă fizică care
            ar necesita transport sau returnare.
          </div>

          <h2>Anulare abonament și restituire plată</h2>
          <p>
            Dacă ai achiziționat un abonament MeniuDigital și dorești anularea acestuia,{' '}
            <strong>poți solicita restituirea integrală a sumei plătite</strong>.
          </p>

          <p>
            Pentru a procesa cererea de anulare și restituire, te rugăm să ne trimiți un email la{' '}
            <a href="mailto:contact@meniudigital.ro">contact@meniudigital.ro</a> cu subiectul{' '}
            <strong>"Anulare abonament"</strong>.
          </p>

          <h2>Informații necesare pentru anulare</h2>
          <p>Te rugăm să incluzi în email următoarele informații:</p>

          <ul>
            <li>
              <strong>Username-ul contului tău</strong> - Contul MeniuDigital pentru care dorești anularea
            </li>
            <li>
              <strong>Data plății și suma</strong> - Pentru identificarea rapidă a tranzacției
            </li>
            <li>
              <strong>Motivul anulării (opțional)</strong> - Ne ajută să îmbunătățim serviciile noastre
            </li>
          </ul>

          <h2>Procesare și confirmare</h2>
          <p>După primirea cererii tale de anulare:</p>

          <ul>
            <li>
              Vom confirma primirea email-ului în <strong>cel mai scurt timp</strong>
            </li>
            <li>Vom procesa anularea abonamentului</li>
            <li>Vom restitui suma plătită pe cardul/contul folosit la achiziție</li>
            <li>Vei primi confirmare după finalizarea restituirii</li>
          </ul>

          <div className="info-box">
            <strong>Notă:</strong> Restituirea sumei se va efectua în termen de maxim 14 zile lucrătoare de la primirea
            cererii, în funcție de băncă și metoda de plată utilizată.
          </div>

          <h2>Încetare abonament</h2>
          <p>
            Dacă nu dorești restituirea sumei, ci doar <strong>încetarea abonamentului pentru perioadele viitoare</strong>,
            poți gestiona acest lucru direct din contul tău:
          </p>

          <ul>
            <li>Abonamentul tău va rămâne activ până la data expirării</li>
            <li>Nu se vor efectua plăți recurente</li>
            <li>Poți reactiva abonamentul oricând</li>
          </ul>

          <p>
            Pentru mai multe detalii despre încetarea abonamentului, vizitează{' '}
            <a href="/my-subscription">pagina de gestionare a abonamentului</a>.
          </p>
        </Content>

        <Footer>
          <h3>Contact</h3>
          <div className="company-info">
            <strong>TOUCHFREEMENU SRL</strong>
            Strada Șugău nr. 46A
            <br />
            Sighetu Marmației, Maramureș 435500
            <br />
            România
            <br />
            <br />
            <strong>E-mail:</strong> <a href="mailto:contact@meniudigital.ro">contact@meniudigital.ro</a>
            <br />
            <br />
            C.U.I.: 44695880
            <br />
            Reg.Com.: J24/1306/05.08.2021
          </div>

          <div className="links">
            <a href="/delivery-terms">Politica de livrare</a>
            <a href="/terms-and-conditions">Termeni și condiții</a>
            <a href="/privacy-policy">Confidențialitate</a>
          </div>
        </Footer>
      </Article>
    </Wrapper>
  )
}
